"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.closeAllMenus = exports.isUiOpen = void 0;
var rogueUiCast_sidecar_1 = require("./rogueUiCast-sidecar");
var rogueUiContext_sidecar_1 = require("./rogueUiContext-sidecar");
var rogueUiCreateCharacter_sidecar_1 = require("./rogueUiCreateCharacter-sidecar");
var rogueUiDead_sidecar_1 = require("./rogueUiDead-sidecar");
var rogueUiHelp_sidecar_1 = require("./rogueUiHelp-sidecar");
var rogueUiInventory_sidecar_1 = require("./rogueUiInventory-sidecar");
var rogueUiLook_sidecar_1 = require("./rogueUiLook-sidecar");
var rogueUiMessages_sidecar_1 = require("./rogueUiMessages-sidecar");
var rogueUiStory_sidecar_1 = require("./rogueUiStory-sidecar");
var isUiOpen = function () {
    var isMenuOpen = rogueUiInventory_sidecar_1.rogueUiInventory.get().isOpen ||
        rogueUiHelp_sidecar_1.rogueUiHelp.get().isOpen ||
        rogueUiMessages_sidecar_1.rogueUiMessages.get().isOpen ||
        rogueUiContext_sidecar_1.rogueUiContext.get().isOpen ||
        rogueUiCast_sidecar_1.rogueUiCast.get().isOpen ||
        rogueUiStory_sidecar_1.rogueUiStory.get().isOpen ||
        rogueUiCreateCharacter_sidecar_1.rogueUiCreateCharacter.get().isOpen ||
        rogueUiDead_sidecar_1.rogueUiDead.get().isOpen;
    return isMenuOpen;
};
exports.isUiOpen = isUiOpen;
var closeAllMenus = function () {
    rogueUiInventory_sidecar_1.rogueUiInventory.close();
    rogueUiHelp_sidecar_1.rogueUiHelp.close();
    rogueUiMessages_sidecar_1.rogueUiMessages.close();
    rogueUiContext_sidecar_1.rogueUiContext.close();
    rogueUiCast_sidecar_1.rogueUiCast.close();
    rogueUiStory_sidecar_1.rogueUiStory.close();
    rogueUiCreateCharacter_sidecar_1.rogueUiCreateCharacter.close();
    rogueUiDead_sidecar_1.rogueUiDead.close();
};
exports.closeAllMenus = closeAllMenus;
var drawAll = function () {
    rogueUiLook_sidecar_1.rogueUiLook.drawAll();
    rogueUiInventory_sidecar_1.rogueUiInventory.drawAll();
    rogueUiMessages_sidecar_1.rogueUiMessages.drawAll();
    rogueUiHelp_sidecar_1.rogueUiHelp.drawAll();
    rogueUiContext_sidecar_1.rogueUiContext.drawAll();
    rogueUiCast_sidecar_1.rogueUiCast.drawAll();
    rogueUiStory_sidecar_1.rogueUiStory.drawAll();
    rogueUiCreateCharacter_sidecar_1.rogueUiCreateCharacter.drawAll();
    rogueUiDead_sidecar_1.rogueUiDead.drawAll();
};
exports.drawAll = drawAll;
